import { useState, useEffect } from 'react';
import AdminLayout from './components/layouts/AdminLayout';
import DashboardOverview from './components/admin/DashboardOverview';
import UserManagement from './components/admin/UserManagement';
import ActivityLog from './components/admin/ActivityLog';
import AdmissionsReport from './components/admin/AdmissionsReport';
import './styles/dashboard.css';

function SuperAdminDashboard({ user, onLogout, apiBase }) {
  const [activeTab, setActiveTab] = useState('overview');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [unreadActivities, setUnreadActivities] = useState(0);

  useEffect(() => {
    const checkActivities = async () => {
      try {
        const response = await fetch(`${apiBase}/admin/update-history`, {
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.ok && Array.isArray(data.data)) {
            setUnreadActivities(data.data.length > 0 ? data.data.length : 0);
          }
        }
      } catch (err) {
        console.error('Error checking activities:', err);
      }
    };

    checkActivities();
    const interval = setInterval(checkActivities, 30000);
    return () => clearInterval(interval);
  }, [apiBase]);

  const handleLogout = async () => {
    if (window.confirm('Anda yakin ingin logout?')) {
      try {
        await fetch(`${apiBase}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });
      } catch (err) {
        console.error('Logout error:', err);
      }
      onLogout();
    }
  };

  const menuItems = [
    { 
      id: 'overview', 
      label: 'Dashboard',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
          <polyline points="12 12 20 7.5" />
          <polyline points="12 12 12 21" />
          <polyline points="12 12 4 7.5" />
        </svg>
      )
    },
    { 
      id: 'users', 
      label: 'Users',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    { 
      id: 'activities', 
      label: 'Activity Log',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
        </svg>
      ),
      badge: unreadActivities > 0 ? unreadActivities : null
    },
    { 
      id: 'admissions', 
      label: 'Admissions Report',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="12" y1="11" x2="12" y2="17" />
          <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
      )
    }
  ];

  const roleColor = '#667eea'; // Purple for Super Admin
  const dashboardTitle = 'Super Admin';

  return (
    <AdminLayout
      user={user}
      onLogout={onLogout}
      roleColor={roleColor}
      dashboardTitle={dashboardTitle}
      menuItems={menuItems}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      <div className="dashboard-content">
        {activeTab === 'overview' && (
          <DashboardOverview apiBase={apiBase} />
        )}

        {activeTab === 'users' && (
          <UserManagement apiBase={apiBase} />
        )}

        {activeTab === 'activities' && (
          <ActivityLog apiBase={apiBase} />
        )}

        {activeTab === 'admissions' && (
          <AdmissionsReport apiBase={apiBase} />
        )}
      </div>
    </AdminLayout>
  );
}

export default SuperAdminDashboard;
